import { createFileRoute, redirect } from '@tanstack/react-router';

// Kept for `/reports` links in emails, push notifications and saved tabs
export const Route = createFileRoute('/_authenticated/reports/')({
  beforeLoad() {
    throw redirect({ to: '/routines', replace: true });
  },
});
